import { Component, Input, OnInit } from '@angular/core';
import { ThemePalette } from '@angular/material/core';

@Component({
    selector: 'app-matspinner',
    templateUrl: './matspinner.component.html',
    styleUrls: ['./matspinner.component.css'],
    standalone: false
})
export class MatspinnerComponent implements OnInit {

  @Input() value: number = 100;
  @Input() diameter: number = 100;
  @Input() mode: string = "indeterminate";
  @Input() strokeWidth: number = 10;
  @Input() overlay: boolean = false;
  @Input() color: ThemePalette = "warn";

  constructor() { }

  ngOnInit(): void {
  }

}
